import type { CostEntryResponse } from '@brickup/shared/models'

/**
 * Where a position can sit, and what names it.
 *
 * Its own module because both halves of the Positionen tab need it — the list
 * filters by a place, the add menu offers them — and a shared word that lives
 * in one of the two makes the two import each other.
 */

/** The filter's widest value: every place at once. */
export const ALL_PLACES = 'all'

/** The filter carries strings, and this one is the building itself. */
export const HOUSE_PLACE = 'house'

/** What the place filter and the add menu name a place by. */
export const placeKey = (roomId: number | null) =>
  roomId == null ? HOUSE_PLACE : String(roomId)

/** What the URL names a row by, and what the pane beside the list reads. */
export const positionKey = (row: CostEntryResponse) => String(row.id)
